function ready(callback) {
	// in case the document is already rendered
	if (document.readyState != 'loading') callback();
	// modern browsers
	else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
	// IE <= 8
	else document.attachEvent('onreadystatechange', function () {
			if (document.readyState == 'complete') callback();
		});
}

ready(function () {
	document.querySelectorAll(".video-container").forEach(function (el) {
		// show loading spinner
		el.classList.add("video-is-loading");

		// add intersection observer for setting the source tag of the video
		var observer = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {

						if (entry.target.classList.contains("video-is-loaded")) {
							return;
						}

						var video = entry.target.querySelector("video");
						var source = video.querySelector("source");
						source.setAttribute("src", window.location.origin + source.getAttribute("data-src"));
						video.load();
						video.addEventListener('loadeddata', function () {
							entry.target.classList.add("video-is-loaded");
							entry.target.classList.remove("video-is-loading");
							if (entry.target.getAttribute("autoplay")) {
								video.play();
							}
						}, false);
						observer.unobserve(entry.target);
					}
				});

			},
			{
				rootMargin: "0px 0px 0px 0px",
				threshold: 0
			});
		observer.observe(el);
	});
});
